import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AiFillStar, AiOutlineStar } from 'react-icons/ai'
import RateItem from './RateItem'
import { ToastContainer } from 'react-toastify'
import Pagination from '../Layout/Pagination'
import RatePost from './RatePost'
import UseReviewItem from "./../../CustomHooks/Reviews/UseReviewItem"
import { BsStarHalf } from 'react-icons/bs'
import ReactStars from "react-rating-stars-component";


const RateContainer = ({ item, IsLogin, role, rateValue, token }) => {
  const [reviewData, onPress, UserLoginId, ReviewUserId, reviewRating, numberOfPages, userChecked] = UseReviewItem({ IsLogin, item })
  const setting = {
    size: 20,
    count: 5,
    color: "#979797",
    activeColor: "#ffc107",
    value: rateValue,
    a11y: true,
    edit: false,
    isHalf: true,
    emptyIcon: <AiOutlineStar />,
    halfIcon: <BsStarHalf />,
    filledIcon: <AiFillStar />
  };
  return (
    <div className='gray-bg py-5 mb-4'>
      <Container >
      {item.ratingsQuantity && item.ratingsQuantity > 0 ? (
          <Row className='px-2 pt-3 pb-4 bg-white mb-3'>
            <div className="fs-30 fw-bold d-inline dark-color">Reviews</div>
            <div className="gray-color fs-14 d-inline">Based on ({item.ratingsQuantity} review)</div>
            {rateValue ? (<ReactStars {...setting} />) : null}
          </Row>
        ) : null}

        <div className='review-post'>
          {reviewData ? (reviewData.map((item, index) => { return (<RateItem key={index} item={item} UserLoginId={UserLoginId} />) })) : null}
        </div>
        {role = "user" && !userChecked ? (
          <Row>
            <div className='p-4 bg-white'>
              <h3>Leave Your Review</h3>
              <RatePost IsLogin={IsLogin} />
            </div>
          </Row>
        ) : null}
        {numberOfPages && numberOfPages > 1 ? (<Pagination onPress={onPress} pageCount={numberOfPages} />) : null}
        <ToastContainer limit={3} />
      </Container>
    </div>


  )
}

export default RateContainer
